import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    justifyContent: 'flex-end',
    backgroundColor: themes.light.modalBackground[1], // Semi-transparent overlay
  },
  modalContainer: {
    width: '100%',
    backgroundColor: themes.light.white[1],
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    // paddingBottom: 16,
    gap: 6,
    overflow: 'hidden',
  },
  divider: {
    width: 80, // Set a fixed width for the divider
    height: 4, // Thin height to mimic Figma style
    backgroundColor: themes.light.gray_blue[6], // Light gray color
    borderRadius: 8, // Rounded edges
    alignSelf: 'center', // Center align the divider
    marginVertical: 8,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingTop: 12,
  },
  closeIcon: {
    width: 24,
    height: 24,
  },
  closeImage: {
    width: 20,
    height: 20,
    resizeMode: 'contain',
  },
  subtitleContainer: {
    paddingHorizontal: 16,
    paddingBottom: 8,
  },
  subtitleText: {
    // fontSize: 14,
    color: themes.light.gray_blue[3],
  },
  mapContainer: {
    height: '60%',
    backgroundColor: themes.light.gray_blue[5],
  },
  footerContainer: {
    paddingVertical: 8,
    paddingHorizontal: 16,
  },
  addressContainer: {
    justifyContent: 'center',
  },
  addressText: {
    color: themes.light.gray_blue[3],
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    // paddingHorizontal: 16,
    // paddingTop: 12,
    gap: 8,
    padding: 16,
    borderTopWidth: 1,
    borderTopColor: themes.light.gray_blue[6],
  },
  buttonWrapper1: {
    flex: 1, // Allow it to grow
    maxWidth: '33%', // Restrict to 33% width
  },
  buttonWrapper2: {
    flex: 1, // Allow it to grow
    maxWidth: '67%', // Restrict to 67% width
  },
});
